import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { setting } from '../../../../../setting';
import { ClientService } from '../../../services/client.service'

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit, AfterViewInit {

  clientSetting: any;


  constructor(private elementRef: ElementRef, private route: ActivatedRoute, private clientService: ClientService) {}
  ngOnInit(): void {

        this.clientService.clientData$.subscribe((data) => {
            		this.clientSetting = data;
      });

        // Si ya hay datos disponibles sincrónicamente
      if (this.clientService.getClientData()) {
            this.clientSetting = this.clientService.getClientData();
      }


  }

  ngAfterViewInit() {


    this.route.fragment.subscribe((fragment: string) => {
      if (fragment) {
        const element = document.getElementById(fragment);
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
          }, 500);
        }
      }
    });
  }

}
